import { memo } from 'react';

import { usePublicCustomFieldsPanel } from '~/components/PublicBoard/components/PublicBoardCustomFieldsPanelContent/hooks/usePublicCustomFieldsPanel';
import { BoardBlurbCustomFields } from '~/components/Workspace/BoardHeader/BoardCrumbs/BoardBlurbCustomFields';
import { usePublicBoardCustomFieldsData } from '~/swr-hooks/customFields/usePublicBoardCustomFieldsData';

export const PublicBoardHeaderCustomFields = memo(() => {
  const { data: boardCustomFields } = usePublicBoardCustomFieldsData();
  const { togglePanel } = usePublicCustomFieldsPanel();
  const hasCustomFields = boardCustomFields?.data && boardCustomFields.data.length > 0;

  if (!hasCustomFields) {
    return null;
  }

  return (
    <div className="flex shrink-0 flex-wrap gap-2 p-2" data-testid="PUBLIC_BOARD_HEADER_CUSTOM_FIELDS">
      <BoardBlurbCustomFields customFields={boardCustomFields.data} onPanelClick={togglePanel} />
    </div>
  );
});

PublicBoardHeaderCustomFields.displayName = 'PublicBoardHeaderCustomFields';
